export default __webpack_public_path__ + "static/media/sandboxx-gift-card-vertical.8c9768a1.png";